import React from 'react'
import PropTypes from 'prop-types'
import { Portal } from 'react-native-paper'
import { Modalize, Modal } from '../../../../components'
import { usePlatforms } from '../../../../hooks/usePlatforms'

const EditAssignedModal = ({ children, open, onClose }) => {
  const { isTablet } = usePlatforms()
  return (
    isTablet ? (
      <Modal
        open={open}
        onClose={onClose}
        title='Edit Order'
      >
        {children}
      </Modal>
    )
      : (
        <Portal>
          <Modalize
            open={open}
            onClose={onClose}
            autoHandleClose
            adjustToContentHeight
          >
            {children}
          </Modalize>
        </Portal>
      )
  )
}

EditAssignedModal.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default EditAssignedModal
